<template>
	<!-- 导航跳转有bug -->
	<div class="case_wrap">
		<el-container>
			<el-aside width="250px">
				<el-menu default-active="/commonPage" router>
					<!--<router-link :to="{name:indexArray[usertype],params:{token:token}}" class="b_index">返回首页</router-link>-->
					<router-link :to="{name:'mainPase'}"  class="b_index">返回首页</router-link>
					<div class="nav_box">
						<a>案件管理</a>
						<router-link class="ha active" :to="{name:finishArray[usertype],params:{token:token}}">已完成救援案件列表</router-link>
					</div>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import "isomorphic-fetch";
	import constants from '@/util/constants.js';
	import Promise from 'promise-polyfill';

	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		data() {
			return {
				token: this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data,
				insti: this.$route.params.insti || JSON.parse(window.localStorage.getItem("insti")),
				usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
				finishArray: ["Finish", "ComFinish", "RegFinish"],
				indexArray: ["FacIndex", "ComIndex", "RegIndex"]
			};
		},
		methods: {
			back() {}
		},
		mounted() {
			let that = this;
			if(that.usertype == 0) {
				that.routeNameType = "Finish";
			}
			if(that.usertype == 2) {
				that.routeNameType = "RegFinish";
			}

		},
		updated() {
			this.typeId = this.$route.query.typeId;
		}
	};
</script>

<style scoped>
	@import url(../../css/caseindex.css);
.active{background: #00abfa;
    color: #fff;}
</style>


// WEBPACK FOOTER //
// src/components/fac/FinishIndex.vue